export function generateBlockId(slideId) {
  return `b-${slideId}-${(Math.random() + 1).toString(36).substring(6)}`
}

export const hasTag = (tag) => {
  return (block) => block.tag === tag
}

export const hasType = (type) => {
  return (block) => block.type === type
}

export function isBlockExist(currentCanvasBlocks, validator) {
  if (!currentCanvasBlocks || Object.keys(currentCanvasBlocks).length === 0) return false
  return Object.values(currentCanvasBlocks).some(validator)
}

export const defaultHeadingText = 'Click to add title'
